function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as h } from "react/jsx-runtime";
import { assignInlineVars as m } from "@vanilla-extract/dynamic";
import l from "classnames";
import * as c from "react";
import { useIsomorphicLayoutEffect as f } from "../hooks.js";
import { container as w, containerWithWrapper as R, vars as b, wrapper as g } from "./aspect-ratio-support.css-mistica.js";
const u = /*#__PURE__*/ c.createContext(!0), x = (param)=>{
    let { children: t  } = param;
    const [o, s] = c.useState(!0);
    return f(()=>{
        try {
            CSS.supports("aspect-ratio", "1 / 1") || s(!1);
        } catch (e) {
            s(!1);
        }
    }, []), /* @__PURE__ */ h(u.Provider, {
        value: o,
        children: t
    });
}, N = ()=>c.useContext(u), W = (t)=>{
    const o = N(), s = typeof t.width != "number" && typeof t.height != "number" && t.aspectRatio !== 0, e = s ? t.aspectRatio : void 0;
    let i = t.width, a = t.height;
    t.width !== void 0 && t.height !== void 0 ? (i = t.width, a = t.height) : typeof t.width == "number" ? a = t.aspectRatio !== 0 ? t.width / t.aspectRatio : void 0 : typeof t.height == "number" ? i = t.aspectRatio !== 0 ? t.height * t.aspectRatio : void 0 : i = t.width || "100%";
    var _t_as;
    const n = s && !o, r = /*#__PURE__*/ c.createElement((_t_as = t.as) !== null && _t_as !== void 0 ? _t_as : "div", _object_spread({
        className: l(t.className, w, {
            [R]: n
        }),
        style: _object_spread({}, n ? _object_spread_props(_object_spread({}, t.style), {
            position: e ? "absolute" : "static",
            width: "100%"
        }) : _object_spread_props(_object_spread({}, t.style), {
            width: isNaN(Number(i)) ? i : Number(i),
            height: isNaN(Number(a)) ? a : Number(a)
        }), m({
            [b.aspectRatio]: e ? String(e) : "unset"
        }))
    }, !n && t.dataAttributes), t.children);
    if (n) {
        const d = (()=>e ? t.width && typeof t.width == "string" && t.width.endsWith("%") ? `${Number(t.width.replace("%", "")) / e}%` : `${100 / e}%` : 0)();
        return /* @__PURE__ */ h("div", _object_spread_props(_object_spread({
            style: {
                width: i,
                height: a,
                paddingTop: d
            },
            className: g
        }, t.dataAttributes), {
            children: r
        }));
    } else return r;
};
export { W as AspectRatioContainer, x as AspectRatioSupportProvider, N as useSupportsAspectRatio };
